import * as React from 'react';
import Text from 'components/Text';
// @ts-ignore
import LTISetup from 'admin/components/LTISetup';

const b = (str: TemplateStringsArray) => <Text weight="semibold">{str}</Text>;

type LTI = {
  config?: {
    configUrl?: string;
  };
};

const stepsFn = (lti: LTI) => {
  const url = lti?.config?.configUrl || '*generate credential to generate URL*';

  const steps = [
    <>Log into your LMS account in a new tab or window</>,
    <>Go to the page where you configure LTI integrations for your LMS</>,
    <>
      Click {b`Generate Credentials`} below to generate a {b`Consumer Key`} and a {b`Shared Secret`}
      . Then go to your LMS and enter them into their respective fields
    </>,
    <>
      Enter the Config XML {url} into the {b`Config URL`} field.
    </>,
    <>Click {b`Submit`}</>,
  ].map(text => <Text size="medium">{text}</Text>);

  return {
    steps,
    keyGeneratorStep: 3,
  };
};

type Props = {
  lti: any;
  deleteLTI: () => Promise<undefined>;
  onDone: () => void;
  rotateCredentials: () => Promise<{ clientId: any; clientSecret: any }>;
};

function OtherLTI(props: Props) {
  return <LTISetup {...props} name="" stepsFn={stepsFn} images={[]} />;
}

export default OtherLTI;
